import React from 'react';
import { Input } from '@roger/ui-components';
import { Question } from '../types';

interface NumberQuestionProps {
  question: Question;
  value: number | string;
  onChange: (value: number | string) => void;
}

export const NumberQuestion: React.FC<NumberQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Allow empty string for clearing the field
    if (inputValue === '') {
      onChange('');
      return;
    }

    // Convert to number if valid
    const numValue = parseFloat(inputValue);
    if (!isNaN(numValue)) {
      onChange(numValue);
    }
  };

  return (
    <div className='space-y-3'>
      <label className='text-sm font-medium text-gray-900 block'>
        {question.description}
        {question.qid && (
          <span className='ml-2 text-xs text-gray-500'>({question.qid})</span>
        )}
      </label>

      <Input
        type='number'
        value={value?.toString() || ''}
        onChange={handleChange}
        placeholder='Enter a number...'
        className='max-w-md'
      />
    </div>
  );
};
